/**
 * Service-worker registration. Runs idempotently — safe to call from any
 * entry point. The SW itself lives at /sw.js and is generated by Vite from
 * `viz/public/sw.js` (copied verbatim).
 *
 * No-ops when:
 *   - the runtime doesn't support service workers (older Safari, etc.)
 *   - the page is loaded from `file://` or another non-HTTP origin
 */
export function registerPwa(): void {
  if (typeof navigator === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (!/^https?:$/.test(window.location.protocol)) return;

  // Defer until after the page has finished loading so the SW install never
  // competes with the initial render.
  window.addEventListener("load", () => {
    void navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => {
        // Surface only in dev — production users don't need to see this.
        // eslint-disable-next-line no-console
        console.warn("[pwa] service worker registration failed:", err);
      });
  });
}
